import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// Author data
export const features = [
  {
    title: "The Odyssey",
    description:
      "Epic poem tracing Odysseus’s journey home after the Trojan War.",
    imgSrc: "../media/nib.jpg",
    alt: "Books organized by language in a minimalist interface.",
  },
  {
    title: "The Divine Comedy",
    description:
      "Medieval vision of the afterlife: Inferno, Purgatorio, Paradiso.",
    imgSrc: "../media/shelf.jpg",
    alt: "Curated bookshelf with short literary summaries.",
  },
  {
    title: "Don Quixote",
    description:
      "Satirical novel about an aging knight who mistakes fantasy for reality.",
    imgSrc: "../media/to-read.jpg",
    alt: "Minimal reading list showcasing global literature.",
  },
  {
    title: "Gitanjali",
    description:
      "Spiritual poems blending devotion and humanism.",
    imgSrc: "../media/typewriter.jpg",
    alt: "Minimal workspace focused on reading and writing.",
  },
  {
    title: "Crime and Punishment",
    description:
      "Psychological novel exploring guilt, redemption, and moral complexity.",
    imgSrc: "../media/author.jpg",
    alt: "Author notes and contextual literary insights.",
  },
  {
    title: "One Hundred Years of Solitude",
    description:
      "Magical realist masterpiece chronicling the Buendía family.",
    imgSrc: "../media/reading.jpg",
    alt: "Reader exploring books across cultures.",
  },
  {
    title: "Things Fall Apart",
    description:
      "A powerful narrative of colonial disruption and cultural conflict in pre-colonial Nigeria.",
    imgSrc: "../media/nib.jpg",
    alt: "Books organized by language in a minimalist interface.",
  },
  {
    title: "Norwegian Wood",
    description:
      "A coming-of-age novel exploring love, loss, and youth in 1960s Japan.",
    imgSrc: "../media/shelf.jpg",
    alt: "Curated bookshelf with short literary summaries.",
  },
  {
    title: "To the Lighthouse",
    description:
      "Modernist novel exploring time, memory, and perception.",
    imgSrc: "../media/to-read.jpg",
    alt: "Minimal reading list showcasing global literature.",
  },
  {
    title: "The Stranger",
    description:
      "Philosophical novel exploring existentialism and the absurd.",
    imgSrc: "../media/typewriter.jpg",
    alt: "Minimal workspace focused on reading and writing.",
  },
  {
    title: "My Name Is Red",
    description:
      "A layered novel exploring identity, art, and East–West tensions.",
    imgSrc: "../media/author.jpg",
    alt: "Author notes and contextual literary insights.",
  },
  {
    title: "Beloved",
    description:
      "A haunting exploration of slavery’s legacy and the power of memory.",
    imgSrc: "../media/reading.jpg",
    alt: "Reader exploring books across cultures.",
  },
];

// Helper: generate slug from author name
const generateSlug = (name) => name.toLowerCase().replace(/\s+/g, "-");

export const Literary = () => {
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  return (
    <section id="booksummaries" style={{ padding: "5rem 0", backgroundColor: "#fff" }}>
      <div className="container text-center">

        {/* Tag */}
        <div
          data-aos="fade-up"
          style={{
            display: "inline-block",
            marginBottom: "1rem",
            padding: "0.4rem 1rem",
            borderRadius: "999px",
            border: "1px solid #ddd",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            fontWeight: 600,
          }}
        >
          Literary
        </div>

        {/* Heading */}
        <h2
          data-aos="fade-up"
          data-aos-delay="100"
          style={{
            maxWidth: "700px",
            margin: "0 auto 1rem",
            fontWeight: 700,
          }}
        >
          Voices That Shaped World Literature
        </h2>

        {/* Subtitle */}
        <p
          data-aos="fade-up"
          data-aos-delay="200"
          style={{
            maxWidth: "700px",
            margin: "0 auto 3rem",
            color: "#6c757d",
          }}
        >
          A focused exploration of writers whose works continue to define
          cultures, movements, and literary traditions.
        </p>

        {/* Cards */}
        <div className="row g-4">
          {features.map((feature, idx) => {
            const isHovered = hovered === idx;
            const slug = generateSlug(feature.title);

            return (
              <div
                key={idx}
                className="col-12 col-md-6 col-lg-3 d-flex"
                data-aos="zoom-in"
                data-aos-delay={idx * 100}
              >
                <a
                  href={`/literary/${slug}`}
                  style={{
                    width: "100%",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                  aria-label={feature.title}
                >
                  <div
                    onMouseEnter={() => setHovered(idx)}
                    onMouseLeave={() => setHovered(null)}
                    style={{
                      height: "100%",
                      padding: "1rem",
                      borderRadius: "1rem",
                      backgroundColor: "#fff",
                      boxShadow: isHovered
                        ? "0 14px 35px rgba(0,0,0,0.12)"
                        : "0 4px 12px rgba(0,0,0,0.08)",
                      transform: isHovered
                        ? "translateY(-6px)"
                        : "translateY(0)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={feature.imgSrc}
                      alt={feature.alt}
                      style={{
                        width: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />

                    <h5
                      style={{
                        marginBottom: "0.25rem",
                        fontWeight: 600,
                        color: isHovered ? "#000" : "#212529",
                        transition: "color 0.3s ease",
                      }}
                    >
                      {feature.title}
                    </h5>

                    <p
                      style={{
                        margin: 0,
                        fontSize: "0.9rem",
                        color: "#6c757d",
                      }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
